export const getShippingDeliveryWindowErrorMessage = (
  startDate?: Date | null,
  endDate?: Date | null,
  minimumShippingWindow?: number,
) => {
  if (minimumShippingWindow && startDate) {
    if (startDate && !endDate) {
      return `End date must be at least ${minimumShippingWindow} days after start date`
    }
  } else {
    if (startDate && endDate && startDate > endDate) {
      return 'Start date must be before end date'
    }

    if (startDate && !endDate) {
      return 'End date is required'
    }
    if (!startDate && endDate) {
      return 'Start date is required'
    }
    if (!startDate && !endDate) {
      return 'Start date and end date are required'
    }
  }

  return undefined
}
